<div class="v3-root">
  @if (showZeroMobileHeader()) {
    @if (isMainPage) {
      <app-v3-powered-by-header></app-v3-powered-by-header>
      <app-v3-stock-header
        [stockName]="stockName"
        [stockLogo]="stockLogo"
        [price]="price"
        [prevPrice]="prevPrice"
        [companyAvailable]="companyAvailable"
        (companyClicked)="companyClicked.emit()"
        (closeClicked)="closeClicked.emit()"
      ></app-v3-stock-header>
    } @else {
      <app-v3-analysis-header
        [stockLogo]="stockLogo"
        [title]="pageTitle"
        [updatedAt]="updatedAt"
        [showInfoButton]="showInfoButton"
        (backClicked)="subpageBackClicked.emit()"
        (infoClicked)="infoClicked.emit()"
      ></app-v3-analysis-header>
    }
    @if (showChatCard()) {
      <app-v3-chat-card></app-v3-chat-card>
    }
  }
  @if (showFinnetBreadcrumb()) {
    <app-v3-finnet-breadcrumb
      [title]="pageTitle"
      [infoOpensPage]="true"
      [showInfoButton]="showInfoButton"
      (homeClicked)="subpageBackClicked.emit()"
      (infoClicked)="infoClicked.emit()"
    ></app-v3-finnet-breadcrumb>
  }
  @if (showFinnetTabNavigation()) {
    <app-v3-tab-navigation
      [activeTab]="activeTab"
      [tabs]="tabs"
      [showInfoButton]="true"
      (tabChange)="tabChange.emit($event)"
    ></app-v3-tab-navigation>
  }
  @if (showRegwall) {
    <app-v3-regwall-info></app-v3-regwall-info>
  }
  <ng-template #projectedContent>
    <ng-content></ng-content>
  </ng-template>
  <ng-template #pageContent>
    @if (showFinnetSubpageWrapper()) {
      <app-v3-finnet-subpage-card
        [title]="pageTitle"
        [updatedAt]="updatedAt"
        [showInfoButton]="showInfoButton"
        (infoClicked)="infoClicked.emit()"
      >
        <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
      </app-v3-finnet-subpage-card>
    } @else if (showZeroSubpageWrapper()) {
      <app-v3-zero-subpage-card
        [title]="pageTitle"
        [icon]="pageIcon"
        [updatedAt]="updatedAt"
        [showInfoButton]="showInfoButton"
        (infoClicked)="infoClicked.emit()"
      >
        <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
      </app-v3-zero-subpage-card>
    } @else {
      <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
    }
  </ng-template>
  @if (showZeroDesktopHeader()) {
    <div class="zero-desktop-shell">
      <app-v3-powered-by-header
        [desktop]="true"
        (closeClicked)="closeClicked.emit()"
      ></app-v3-powered-by-header>
      <app-v3-zero-desktop-header
        [stockName]="stockName"
        [stockLogo]="stockLogo"
        [price]="price"
        [prevPrice]="prevPrice"
        [activeTab]="activeTab"
        [tabs]="tabs"
        (subpageBackClicked)="subpageBackClicked.emit()"
        (tabChange)="tabChange.emit($event)"
      ></app-v3-zero-desktop-header>
      @if (showChatCard()) {
        <app-v3-chat-card></app-v3-chat-card>
      }
      <ng-container [ngTemplateOutlet]="pageContent"></ng-container>
      <app-v3-conditions-footer></app-v3-conditions-footer>
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="pageContent"></ng-container>
    <app-v3-conditions-footer></app-v3-conditions-footer>
  }
</div>
